import React, { useState } from 'react';
import './Wager.css'

export default function Wager({startMoney, callback}) {

  const [wager, setWager] = useState(0);
  const [money] = useState(startMoney);

  function changeWager(increase) {
    if(increase && wager + 10 <= money) {
      setWager(wager + 10)
    }
    else {
      if(wager - 10 >= 0)
      setWager(wager - 10)
    }
  }

  function dealHandler() {
    if(wager > 0) {
      callback(wager);
    }
    else {
      alert("You must wager more than $0")
    }
  }

  return (
    <div className="wager-container">
      <span className="wager-text">Wager: $ </span>

      <div className="wager-amount">
        {wager}
      </div>

      <div  className="wager-incr"></div>

      <div className="wager-incr-decr">
        <div
          className="arrow-up"
          onClick={ () => {changeWager(true)} } >
        </div>

        <div
          className="arrow-down"
          onClick={ () => {changeWager(false)} } >
        </div>
      </div>

      <button
            className="wager-deal"
            onClick={dealHandler}>
            Deal
      </button>

    </div>
  );
}
